var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.3,29.2c-1,0-1.9-0.4-2.5-1.1c-1.8-1.9-3.6-3.8-5.5-5.6c-1.4-1.4-1.4-3.8,0-5.3v-0.1c5.1-5.3,10.3-10.7,15.5-16 c1.4-1.5,3.7-1.5,5.1,0c1.9,1.9,3.7,3.8,5.5,5.7c1.4,1.4,1.4,3.7,0,5.2L27,12.4L12,28C11.3,28.8,10.3,29.2,9.3,29.2z M9.3,27.6 c0.6,0,1.2-0.2,1.6-0.7l7-7.2c0.2-0.2,0.2-0.3,0-0.4c-2.7-2.8-5.4-5.6-8.2-8.4c-0.1-0.1-0.2-0.1-0.4,0l-7,7.2 c-0.9,0.9-0.9,2.3,0,3.1c1.9,2,3.7,3.9,5.5,5.8C8.2,27.4,8.8,27.6,9.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,30H1c-0.8,0-1-0.2-1-1.2c0-0.2,0-0.4,0-0.6c0.1-0.3,0.4-0.5,0.7-0.5h28.4c0.6,0,0.9,0.3,0.9,1c0,0.1,0,0.2,0,0.3 c0,0.6-0.3,0.9-0.8,0.9L15,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.d7031b25d59394a2d77321fc14371cb9.svg";
export { ForwardRef as ReactComponent };